import { render, staticRenderFns } from "./apply_payment_goods.vue?vue&type=template&id=3f5cd207&scoped=true&"
import script from "./apply_payment_goods.vue?vue&type=script&lang=js&"
export * from "./apply_payment_goods.vue?vue&type=script&lang=js&"
import style0 from "./apply_payment_goods.vue?vue&type=style&index=0&id=3f5cd207&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f5cd207",
  null
  
)

export default component.exports